import { render, staticRenderFns } from "./AddInstitutionToPersonModal.vue?vue&type=template&id=e657ebc6&scoped=true&"
import script from "./AddInstitutionToPersonModal.vue?vue&type=script&lang=js&"
export * from "./AddInstitutionToPersonModal.vue?vue&type=script&lang=js&"
import style0 from "./AddInstitutionToPersonModal.vue?vue&type=style&index=0&id=e657ebc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e657ebc6",
  null
  
)

export default component.exports